
  angular.module("ticketco/ticketbuyer/common").directive("tcBindEmpty", tcBindEmpty);

  function tcBindEmpty() {
    return {
      require: "ngModel",
      link: function (scope, elem, attrs, ngModelCtrl) {
        scope.$watch(attrs.tcBindEmpty, function (newValue, oldValue) {
          if (newValue == null) return;
          
          if (ngModelCtrl.$viewValue === oldValue || ngModelCtrl.$isEmpty(ngModelCtrl.$viewValue)) {
            ngModelCtrl.$setViewValue(newValue, "change");
            ngModelCtrl.$render();
          }
        });
      },
    };
  }

